import { createFileRoute } from '@tanstack/react-router'
import { ConnectAccounts } from '~/features/crossposting/components/connect-accounts'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/connect')({
  validateSearch: (search: Record<string, unknown>) => ({
    connected: search.connected === '1' ? ('1' as const) : undefined,
  }),
  component: ConnectRoute,
})

function ConnectRoute() {
  const { listingId } = Route.useParams()
  const { connected } = Route.useSearch()
  return <ConnectAccounts listingId={listingId} justReturned={connected === '1'} />
}
